import { useEffect, useState } from "react";
import { NJInlineMessage } from "@engie-group/fluid-design-system-react";
import {
  type Notification,
  dismissNotification,
  subscribeNotifications,
} from "@/api/apiErrorStore";

const AUTO_DISMISS_MS = 8000;

/** Global notification stack (top of the screen). Every error/success/info goes through here,
 * shown as a dismissible NJInlineMessage; each entry auto-dismisses after a few seconds. */
export function NotificationCenter() {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => subscribeNotifications(setNotifications), []);

  useEffect(() => {
    if (notifications.length === 0) return;
    const timers = notifications.map((notification) =>
      window.setTimeout(
        () => dismissNotification(notification.id),
        AUTO_DISMISS_MS,
      ),
    );
    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [notifications]);

  if (notifications.length === 0) return null;

  return (
    <div className="fixed inset-x-0 top-3 z-[60] mx-auto flex w-full max-w-2xl flex-col gap-2 px-4">
      {notifications.map((notification) => (
        <NJInlineMessage
          key={notification.id}
          variant={notification.variant}
          ariaLabelClose="Dismiss"
          onClose={() => dismissNotification(notification.id)}
        >
          {notification.message}
        </NJInlineMessage>
      ))}
    </div>
  );
}
